/* HustleKing - interazioni. Vanilla JS, zero dipendenze. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('[data-hk-reveal]');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('hk-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var group = el.parentElement;
        var delay = 0;
        if (group && group.hasAttribute('data-hk-stagger')) {
          delay = Array.prototype.indexOf.call(group.children, el) * 80;
          if (delay > 480) delay = 480;
        }
        el.style.setProperty('--hk-delay', delay + 'ms');
        el.classList.add('hk-in');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initHeader() {
    var hdr = document.querySelector('[data-hk-header]');
    if (!hdr) return;
    var tick = false;
    function upd() { hdr.classList.toggle('hk-stuck', window.scrollY > 8); tick = false; }
    window.addEventListener('scroll', function () {
      if (tick) return;
      tick = true;
      window.requestAnimationFrame(upd);
    }, { passive: true });
    upd();
  }

  function initFaq() {
    document.querySelectorAll('[data-hk-faq]').forEach(function (item) {
      var btn = item.querySelector('.hk-faq__q');
      if (!btn) return;
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var open = item.classList.contains('hk-open');
        var wrap = item.closest('[data-hk-faqs]');
        if (wrap) {
          wrap.querySelectorAll('[data-hk-faq].hk-open').forEach(function (o) {
            if (o === item) return;
            o.classList.remove('hk-open');
            var b = o.querySelector('.hk-faq__q');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
        }
        item.classList.toggle('hk-open', !open);
        btn.setAttribute('aria-expanded', String(!open));
      });
    });
  }

  function initSticky() {
    var bar = document.querySelector('[data-hk-sticky]');
    if (!bar) return;
    var trigger = document.querySelector('[data-hk-sticky-after]');
    var tick = false;
    function upd() {
      var pass = trigger ? trigger.getBoundingClientRect().bottom < 0 : window.scrollY > window.innerHeight * 0.6;
      var nearFoot = (window.innerHeight + window.scrollY) > (document.body.offsetHeight - 220);
      bar.classList.toggle('hk-on', pass && !nearFoot);
      tick = false;
    }
    window.addEventListener('scroll', function () {
      if (tick) return;
      tick = true;
      window.requestAnimationFrame(upd);
    }, { passive: true });
    upd();
  }

  function initAnchors() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a) return;
      var id = a.getAttribute('href');
      if (!id || id === '#') return;
      var t = document.querySelector(id);
      if (!t) return;
      e.preventDefault();
      var top = t.getBoundingClientRect().top + window.scrollY - 70;
      window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  function initGallery() {
    var g = document.querySelector('[data-hk-gallery]');
    if (!g) return;
    var main = g.querySelector('[data-hk-gallery-main]');
    g.querySelectorAll('[data-hk-thumb]').forEach(function (th) {
      th.addEventListener('click', function () {
        var src = th.getAttribute('data-src');
        var alt = th.getAttribute('data-alt') || '';
        if (main && src) {
          main.style.opacity = '0';
          setTimeout(function () { main.src = src; main.alt = alt; main.style.opacity = '1'; }, 130);
        }
        g.querySelectorAll('[data-hk-thumb]').forEach(function (o) { o.classList.remove('hk-act'); });
        th.classList.add('hk-act');
      });
    });
    if (main) main.style.transition = 'opacity .25s ease';
  }

  function initVariants() {
    var root = document.querySelector('[data-hk-variants]');
    if (!root) return;
    var data;
    try { data = JSON.parse(root.getAttribute('data-hk-variants')); } catch (err) { return; }
    if (!data || !data.length) return;
    var idInput = document.querySelector('[data-hk-variant-id]');
    var priceEl = document.querySelector('[data-hk-price]');
    var wasEl = document.querySelector('[data-hk-was]');
    var offEl = document.querySelector('[data-hk-off]');
    var btn = document.querySelector('[data-hk-buy]');
    var stickyPrice = document.querySelector('[data-hk-sticky-price]');
    var sel = {};

    function fmt(cents) { return '€' + (cents / 100).toFixed(2).replace('.', ','); }

    function match() {
      var names = Object.keys(sel);
      return data.filter(function (v) {
        return names.every(function (n) { return v.options[n] === sel[n]; });
      })[0];
    }

    function render() {
      var v = match();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = fmt(v.price);
      if (stickyPrice) stickyPrice.textContent = fmt(v.price);
      if (wasEl) {
        if (v.compare && v.compare > v.price) {
          wasEl.textContent = fmt(v.compare);
          wasEl.style.display = '';
          if (offEl) {
            offEl.textContent = '−' + Math.round((1 - v.price / v.compare) * 100) + '%';
            offEl.style.display = '';
          }
        } else {
          wasEl.style.display = 'none';
          if (offEl) offEl.style.display = 'none';
        }
      }
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? btn.getAttribute('data-hk-label') : 'Non disponibile';
      }
    }

    root.querySelectorAll('[data-hk-opt]').forEach(function (b) {
      var name = b.getAttribute('data-hk-opt');
      var val = b.getAttribute('data-hk-val');
      if (b.classList.contains('hk-act')) sel[name] = val;
      b.addEventListener('click', function () {
        sel[name] = val;
        root.querySelectorAll('[data-hk-opt="' + name + '"]').forEach(function (o) { o.classList.remove('hk-act'); });
        b.classList.add('hk-act');
        render();
      });
    });
    render();
  }

  function boot() {
    initReveal();
    initHeader();
    initFaq();
    initSticky();
    initAnchors();
    initGallery();
    initVariants();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
